import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Component } from 'react';
import { Segment } from '../Segment';
import * as style from './Line.css';
export function isLineSelected(ids, selectedIds) {
  return ids.every(function (value) {
    return selectedIds.indexOf(value) >= 0;
  });
}
export var Line = /*#__PURE__*/function (_Component) {
  _inherits(Line, _Component);

  var _super = _createSuper(Line);

  function Line() {
    var _this;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLineNumber", function (isSelected, point, fill, index) {
      return /*#__PURE__*/React.createElement("g", {
        transform: "translate(".concat(point.x, " ").concat(point.y, ")"),
        key: index,
        onMouseEnter: function onMouseEnter() {
          return _this.props.onHover(_this.props.data.ids);
        },
        onMouseLeave: _this.props.onLeave,
        onClick: function onClick() {
          if (isSelected) {
            _this.props.onRemove(_this.props.data.ids);
          } else {
            _this.props.onSelect(_this.props.data.ids);
          }
        }
      }, /*#__PURE__*/React.createElement("circle", {
        className: style['line_number'],
        cx: "0",
        cy: "0",
        r: "6.5",
        fill: fill
      }), /*#__PURE__*/React.createElement("text", {
        className: style['line_title'],
        style: point.text.size ? {
          fontSize: "".concat(point.text.size)
        } : {},
        fill: point.text.fill // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: point.text.value
        },
        transform: "translate(".concat(point.text.x, " ").concat(point.text.y, ")")
      }));
    });

    return _this;
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$stationsU = this.props.stationsUnderConstruction,
          stationsUnderConstruction = _this$props$stationsU === void 0 ? [] : _this$props$stationsU;
      var shakedSegments = shakeSegments(this.props.data.segments, stationsUnderConstruction);
      var segments = shakedSegments.map(function (segment) {
        return /*#__PURE__*/React.createElement(Segment, {
          key: segment.key,
          lineColor: _this2.props.data.color,
          data: segment,
          stationsUnderConstruction: stationsUnderConstruction,
          isSelected: isLineSelected(segment.ids, _this2.props.selectedIds),
          onHover: _this2.props.onHover,
          onLeave: _this2.props.onLeave,
          onSelect: _this2.props.onSelect,
          onRemove: _this2.props.onRemove
        });
      });
      var isSelected = isLineSelected(this.props.data.ids, this.props.selectedIds);
      var lineNumbers = this.props.data.points.map(function (value, index) {
        return _this2.renderLineNumber(isSelected, value, _this2.props.data.color, index);
      });
      return /*#__PURE__*/React.createElement("g", {
        stroke: this.props.data.color
      }, lineNumbers, segments);
    }
  }]);

  return Line;
}(Component);

function shakeSegments(segments, stationsUnderConstruction) {
  return segments.map(function (segment) {
    if (typeof segment.parentId !== 'undefined' && segments.some(function (s) {
      return s.id === segment.parentId;
    })) {
      return _objectSpread(_objectSpread({}, segment), {}, {
        ids: segment.ids.filter(function (id) {
          return stationsUnderConstruction.indexOf(id) !== -1;
        }),
        parts: segment.parts.filter(function (part) {
          return !part.ids || part.ids.filter(function (pId) {
            return stationsUnderConstruction.indexOf(pId) !== -1;
          }).length > 0;
        })
      });
    } else if (segments.some(function (s) {
      return s.parentId === segment.id;
    })) {
      var nextIds = segments.reduce(function (ids, s) {
        if (s.parentId === segment.id) {
          return ids.concat(s.ids.filter(function (i) {
            return stationsUnderConstruction.indexOf(i) === -1;
          }));
        }

        return ids;
      }, segment.ids);
      var nextParts = segments.reduce(function (parts, s) {
        if (s.parentId === segment.id) {
          return parts.concat(s.parts.filter(function (p) {
            return p.ids && p.ids.filter(function (pId) {
              return stationsUnderConstruction.indexOf(pId) !== -1;
            }).length === 0;
          }));
        }

        return parts;
      }, segment.parts);
      return _objectSpread(_objectSpread({}, segment), {}, {
        ids: nextIds,
        parts: nextParts
      });
    }

    return segment;
  }).filter(function (segment) {
    return segment.parts.length > 0;
  });
}